<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useUiStore } from '@/stores/ui'
import { useAuthStore } from '@/stores/auth'
import { useNotificationsStore } from '@/stores/notifications'
import AppBreadcrumb from './AppBreadcrumb.vue'
import NotificationBell from './NotificationBell.vue'
import NotificationDropdown from './NotificationDropdown.vue'

const router = useRouter()
const ui = useUiStore()
const auth = useAuthStore()
const notifications = useNotificationsStore()

const showDropdown = ref(false)

function toggleDropdown() {
  showDropdown.value = !showDropdown.value
}

function closeDropdown() {
  showDropdown.value = false
}

async function handleLogout() {
  await auth.logout()
  router.push({ name: 'login' })
}

onMounted(() => {
  if (auth.isAuthenticated) {
    notifications.startPolling()
  }
})

onUnmounted(() => {
  notifications.stopPolling()
})
</script>

<template>
  <header class="flex h-16 shrink-0 items-center justify-between border-b border-gray-200 bg-white px-6">
    <div class="flex items-center gap-4 min-w-0">
      <!-- Mobile menu toggle -->
      <button
        class="shrink-0 rounded-lg p-1.5 text-gray-500 hover:bg-gray-100 md:hidden"
        aria-label="Abrir menu"
        @click="ui.openSidebar()"
      >
        <span class="plutto-icon plutto-icon--outlined text-xl">menu</span>
      </button>

      <!-- Breadcrumbs -->
      <AppBreadcrumb />
    </div>

    <div class="flex items-center gap-4">
      <!-- Notifications -->
      <div class="relative">
        <NotificationBell
          :count="notifications.unreadCount"
          :expanded="showDropdown"
          @click="toggleDropdown"
        />
        <NotificationDropdown
          :visible="showDropdown"
          @close="closeDropdown"
        />
      </div>

      <!-- User info -->
      <div
        v-if="auth.user"
        class="flex items-center gap-2"
      >
        <div class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-200 text-sm font-medium text-gray-600">
          {{ auth.user.name.charAt(0).toUpperCase() }}
        </div>
        <div class="hidden sm:block">
          <p class="text-sm font-medium text-gray-700">
            {{ auth.user.name }}
          </p>
          <p class="text-xs text-gray-500">
            {{ auth.user.role }}
          </p>
        </div>
        <button
          class="ml-2 rounded-lg p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
          title="Cerrar sesion"
          aria-label="Cerrar sesion"
          @click="handleLogout"
        >
          <span class="plutto-icon plutto-icon--outlined text-xl">logout</span>
        </button>
      </div>
    </div>
  </header>
</template>
